import { createFileRoute, Outlet } from "@tanstack/solid-router";

export const Route = createFileRoute("/_dashboard/dashboard/reports")({
  staticData: {
    breadcrumb: "Reports",
  },
  component: () => <Outlet />,
});
